import api from './api';
import { ApiResponse, PaginatedResponse } from '../types';

export interface Benefit {
  _id: string;
  name: string;
  slug: string;
  status: 'active' | 'inactive';
  isDeleted: boolean;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateBenefitData {
  name: string;
  status: 'active' | 'inactive';
}

const benefitService = {
  async getActiveBenefits(params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<PaginatedResponse<Benefit>>> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    
    const response = await api.get(`/benefit/active?${queryParams.toString()}`);
    return response.data;
  },

  async createBenefit(benefitData: CreateBenefitData): Promise<ApiResponse<Benefit>> {
    const response = await api.post('/benefit', benefitData);
    return response.data;
  }
};

export default benefitService;
